export default "__VITE_ASSET__CPxM9pC3__"